import { InputDateController } from "@components";
import { Button, Modal, Text } from "@pentabd/ui";
import { SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  DISCIPLINE,
  DisciplineUpdateFormDataType,
  disciplineUpdateValidation,
} from "@validations/HRM/employee/disciplineValidation";
import { UpdateDisciplineType } from "@type/HRM/discipline";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";

type Props = {
  isOpen: boolean;
  onClose: (id: number | null) => void;
  onUpdateDiscipline: (data: any) => void;
};

export const CancelSuspendModal = ({
  isOpen,
  onClose,
  onUpdateDiscipline,
}: Props) => {
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<DisciplineUpdateFormDataType>({
    resolver: yupResolver(disciplineUpdateValidation),
  });

  const onSubmit: SubmitHandler<UpdateDisciplineType> = (
    data: UpdateDisciplineType,
  ) => {
    onUpdateDiscipline(data);
  };

  useEffect(() => {
    reset();

    return () => {
      reset();
    };
  }, []);

  return (
    <Modal isOpen={isOpen} onClose={() => onClose(null)} overlay>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="my-10 modal_width suspense-modal">
          <div className="border-bottom pb-5 mb-8 px-20 pt-8">
            <Text component="h3" size="md">
              {t("EMPLOYEE.DISCIPLINE.TABLE.MODAL.TITLE")}
            </Text>
          </div>

          <div className="mb-10 px-20">
            <div className="row">
              <div className="col-12">
                <Text weight="semibold" size="sm" color="title">
                  {t("EMPLOYEE.DISCIPLINE.TABLE.MODAL.FORM.CANCEL_DATE.LABEL")}
                </Text>
                <span className="text-danger">&#42;</span>
              </div>
              <div className="col-12">
                <InputDateController
                  control={control}
                  errors={errors as any}
                  name={DISCIPLINE.SUSPEND_FINISH_DATE}
                  placeholder={t(
                    "EMPLOYEE.DISCIPLINE.TABLE.MODAL.FORM.CANCEL_DATE.PLACEHOLDER",
                  )}
                />
              </div>
            </div>
          </div>

          <div className="mt-5 px-20 pb-10 col-12 text-end">
            <Button
              fill="outline"
              type="warning"
              size="xs"
              className="me-5"
              onClick={() => onClose(null)}
            >
              {t("EMPLOYEE.DISCIPLINE.TABLE.MODAL.CLOSE")}
            </Button>

            <Button fill="fill" type="primary" size="xs" htmlType="submit">
              {t("EMPLOYEE.DISCIPLINE.TABLE.MODAL.SUBMIT")}
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
};
